module.exports = __webpack_public_path__ + "static/img/btnbg.eac8b8fa.png";